// extracted by mini-css-extract-plugin
export var h1 = "headline-module--h1--78392";
export var h2 = "headline-module--h2--57b1b";
export var h3 = "headline-module--h3--5ed84";
export var h4 = "headline-module--h4--03c23";
export var h5 = "headline-module--h5--7f83d";
export var h6 = "headline-module--h6--ea3aa";
export var headlineStyle = "headline-module--headlineStyle--383af";